import React, { useEffect } from 'react'
import Head from 'react-helmet'
import App from '../components/App'
import { setSessionStorage } from '../utils/sessionStorage'
import { Search } from 'react-bootstrap-icons'
import Chip from '../components/atoms/chip/Chip'

export const SUGGESTED_SEARCH_OPTIONS = [
  {
    title: 'Depression',
    link: '/condition/depression/'
  },
  {
    title: 'Drug Addiction',
    link: '/united-states/'
  },
  {
    title: 'Eating Disorders',
    link: '/condition/eating-disorders/'
  },
  {
    title: 'Luxury',
    link: '/luxury/'
  },

  {
    title: 'Insurance Accepted',
    link: '/price/insurance-accepted/'
  }
]

const NotFoundPage = () => {
  useEffect(() => {
    setSessionStorage('searchState', null)
  })

  return (
    <>
      <Head>
        <title>Page Not Found</title>
        <link
          rel="canonical"
          href="https://recovery.com/404/"
        />
        <meta
          name="robots"
          content="noindex"
        />
      </Head>
      <App pageType="Utilities">
        <div className="flex h-[60vh] flex-col items-center justify-center p-8 md:h-[75vh]">
          <div className="flex flex-col items-center justify-center gap-8 pb-[7vh] md:pb-32">
            <div className="flex max-w-[400px] flex-col items-center justify-center gap-6">
              <h1 className="font-FieldsVariable text-[72px] leading-[72px] text-gray-1000">
                404
              </h1>
              <div className="flex flex-col items-center justify-center gap-2">
                <p className="text-lg font-medium text-gray-1000">
                  Sorry, we couldn't find that page
                </p>
                <p className="text-center text-gray-700">
                  Try these suggestions to browse for centers.
                </p>
              </div>
            </div>
            <div className="flex max-w-[400px] flex-row flex-wrap items-center justify-center gap-4">
              {SUGGESTED_SEARCH_OPTIONS.map((option) => (
                <Chip
                  href={option.link}
                  linkTitle={option.title}
                  key={option.title}
                  hasIcon={true}
                >
                  <div className="flex items-center justify-center gap-2">
                    <Search
                      size={16}
                      className="text-gray-1100"
                    />
                    {option.title}
                  </div>
                </Chip>
              ))}
            </div>
          </div>
        </div>
      </App>
    </>
  )
}

export default NotFoundPage
